"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypes = void 0;
var NodeTypes;
(function (NodeTypes) {
    NodeTypes["MarkdownNode"] = "markdown";
    NodeTypes["ErrorNode"] = "error";
    NodeTypes["SignatureNode"] = "signature";
    NodeTypes["TableNode"] = "table";
    NodeTypes["TextBoxNode"] = "textbox";
    NodeTypes["HeaderNode"] = "header";
    NodeTypes["CheckmarkListNode"] = "checkmarkList";
    NodeTypes["StaticCheckmarkListNode"] = "staticCheckmarkList";
})(NodeTypes = exports.NodeTypes || (exports.NodeTypes = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL25vZGVzL3R5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksU0FTWDtBQVRELFdBQVksU0FBUztJQUNuQixzQ0FBeUIsQ0FBQTtJQUN6QixnQ0FBbUIsQ0FBQTtJQUNuQix3Q0FBMkIsQ0FBQTtJQUMzQixnQ0FBbUIsQ0FBQTtJQUNuQixvQ0FBdUIsQ0FBQTtJQUN2QixrQ0FBcUIsQ0FBQTtJQUNyQixnREFBbUMsQ0FBQTtJQUNuQyw0REFBK0MsQ0FBQTtBQUNqRCxDQUFDLEVBVFcsU0FBUyxHQUFULGlCQUFTLEtBQVQsaUJBQVMsUUFTcEIifQ==